var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['app-container']},[_c('global-header',{attrs:{"mode":"light","title":_vm.title,"showBack":_vm.showBack,"background":"#48d5af"}}),_c('router-view',{ref:"child"}),_c('base-service')],1)}
var staticRenderFns = []

export { render, staticRenderFns }